<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row-12">
                <div class="card" style="margin-top:10px">
                    <div class="card-header">
                        <h3 class="card-title">Charge Points - Filter</h3>
                        <div class="subhead"></div>
                    </div>
                    <div class="card-body">
                        <div class="col"></div>
                        <div>
                            <label for="dropdownOcppVersion">Ocpp_version</label>
                            <select v-model="selectedOcppVersion" @change="filterByOcppVersion">
                                <option value="">All</option>
                                <option v-for="version in uniqueOcppVersions" :value="version" :key="version">
                                    {{ version }}
                                </option>
                            </select>
                        </div>
                        <div>
                            <label for="dropdownLoadAreaID">LoadAreaID</label>
                            <select v-model="selectedLoadAreaID" @change="filterByLoadAreaID">
                                <option value="">All</option>
                                <option v-for="loadAreaID in uniqueLoadAreaId" :value="loadAreaID" :key="loadAreaID">
                                    {{ loadAreaID }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row-12">
                    <div class="card" v-if="$gate.isAdmin() || $gate.isIren()">
                        <div class="card-header">
                            <h3 class="card-title">Charging Station - List</h3>
                            <div class="card-tools">
                                <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                                    <i class="fa fa-plus-square"></i>
                                    Add New
                                </button>
                            </div>
                        </div>
                        <div class="card-body table-responsive p-0">
                            <table class="table table-hover">
                                <thead>
                                <tr>
                                    <th>id</th>
                                    <th>ocpp_version</th>
                                    <th>LoadAreaID</th>
                                    <th>mcu_identifier</th>
                                    <th>ocpp_charge_point_id</th>
                                    <th>label</th>
                                    <th>actions</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in filteredItems" :key="item.id">
                                    <td>{{ item.id }}</td>
                                    <td>{{ item.ocpp_version }}</td>
                                    <td>{{ item.LoadAreaID }}</td>
                                    <td>{{ idToNameMap[item.MCU_ID] }}</td>
                                    <td>{{ item.ocpp_charge_point_id }}</td>
                                    <td>{{ item.label }}</td>
                                    <td>
                                        <a href="#" @click="editModal(item)">
                                            <i class="fa fa-edit blue"></i>
                                        </a>/
                                        <a href="#" @click="deleteChargePoint(item.id)">
                                            <i class="fa fa-trash red"></i>
                                        </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

      <div v-if="!$gate.isAdmin() && !$gate.isIren()">
        <not-found></not-found>
      </div>

        <!-- Modal for Adding/Editing Charge Points -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="modalTitle" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" v-show="!editmode">Create New Charge Point</h5>
                        <h5 class="modal-title" v-show="editmode">Update Charge Point Info</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                            <span aria-hidden="true" @click="closeModal">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="editmode ? updateChargePoint() : createChargePoint()">
                            <div class="modal-body">

                                <div class="form-group">
                                    <label for="ocpp_version">OCPP Version</label>
                                    <input type="text" class="form-control" v-model="form.ocpp_version" required>
                                </div>
                                <div class="form-group">
                                    <label for="loadAreaID">Load Area ID</label>
                                    <input type="text" class="form-control" v-model="form.LoadAreaID" required>
                                </div>
                                <div class="form-group">
                                    <label for="ocpp_charge_point_id">OCPP Charge Point ID</label>
                                    <input type="text" class="form-control" v-model="form.ocpp_charge_point_id" >
                                </div>
                                <div class="form-group">
                                    <label for="label">Label</label>
                                    <input type="text" class="form-control" v-model="form.label" >
                                </div>
                                <button type="submit" class="btn btn-primary">{{ editmode ? 'Update' : 'Add' }}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            selectedOcppVersion: '',
            selectedLoadAreaID: '',
            selectedItems: [],
            mcus:[],
            idToNameMap: {},
            editmode: false,
            form: {
                id: '',
                ocpp_version: '',
                LoadAreaID: '',
                MCU_ID: '',
                ocpp_charge_point_id: '',
                label: ''
            }
        };
    },
    mounted() {
        this.fetchItemData();
        this.fetchMcuData();
    },
    computed: {
        uniqueOcppVersions() {
            return [...new Set(this.selectedItems.map(item => item.ocpp_version).filter(ocpp_version => ocpp_version))];
        },
        uniqueLoadAreaId() {
            return [...new Set(this.selectedItems.map(item => item.LoadAreaID).filter(loadAreaID => loadAreaID))];
        },
        filteredItems() {
            return this.selectedItems.filter(item => {
                const versionMatch = this.selectedOcppVersion ? item.ocpp_version === this.selectedOcppVersion : true;
                const loadAreaMatch = this.selectedLoadAreaID ? item.LoadAreaID === this.selectedLoadAreaID : true;
                return versionMatch && loadAreaMatch;
            });
        }
    },
    methods: {
        fetchItemData() {
            axios.get('api/charge-point/')
                .then(response => {
                    this.selectedItems = response.data;
                    console.log('Fetched charge point data:', this.selectedItems);
                })
                .catch(error => {
                    console.error('Error fetching charge point data:', error);
                });
        },
      fetchMcuData() {
        axios.get('api/MCU')  // Replace with your actual API endpoint for MCUs
            .then(response => {
              // Log the raw response data to check its structure
              console.log('Fetched MCU data:', response.data);

              this.mcus = response.data.data;  // response.data.data contains the array of MCUs

              // Check if mcus is an array
              if (Array.isArray(this.mcus)) {
                // Create a map of id to name
                this.idToNameMap = this.mcus.reduce((map, item) => {
                  map[item.mcu_id] = item.mcu_identifier; // Assuming 'mcu_identifier' is the property for the MCU name
                  return map;
                }, {});

                for (const [mcu_id, name] of Object.entries(this.idToNameMap)) {
                  console.log(`ID: ${mcu_id}, Name: ${name}`);
                }
              } else {
                console.error('Expected mcus to be an array, but got:', this.mcus);
              }
            })
            .catch(error => {
              console.error('Error fetching MCU data:', error);
            });
      },
      filterByOcppVersion() {
            console.log('Selected OCPP Version:', this.selectedOcppVersion);
        },
        filterByLoadAreaID() {
            console.log('Selected LoadAreaID:', this.selectedLoadAreaID);
        },
        newModal() {
            this.editmode = false;
            this.resetForm();
            $('#addNew').modal('show');
        },
        editModal(item) {
            this.editmode = true;
            this.resetForm();
            this.form = { ...item };  // Fill the form with the selected item data
            $('#addNew').modal('show');
        },
        closeModal() {
            $('#addNew').modal('hide');
        },
        createChargePoint() {
            axios.post('api/charge-point', this.form)
                .then((response) => {
                    $('#addNew').modal('hide');
                    Toast.fire({
                        icon: 'success',
                        title: 'Charge-Point has been created'
                    });
                    this.fetchItemData();
                })
                .catch(() => {
                    Toast.fire({
                        icon: 'error',
                        title: 'Some error occurred! Please try again'
                    });
                });
        },
        updateChargePoint() {
            axios.put(`api/charge-point/${this.form.id}`, this.form)
                .then((response) => {
                    $('#addNew').modal('hide');
                    Toast.fire({
                        icon: 'success',
                        title: 'Charge Point has been updated'
                    });
                    this.$Progress.finish();
                    this.fetchItemData();
                })
                .catch((error) => {
                    console.error('Error updating Charge Point:', error);
                    this.$Progress.fail();
                    Toast.fire({
                        icon: 'error',
                        title: 'Error updating ChargePoint'
                    });
                });
        },
        deleteChargePoint(id) {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) {
                    axios.delete('api/charge-point/' + id)
                        .then(() => {
                            Swal.fire('Deleted!', 'Charge-Point has been deleted.', 'success');
                            this.fetchItemData();
                        })
                        .catch((data) => {
                            Swal.fire('Failed!', data.message, 'warning');
                        });
                }
            });
        },
        resetForm() {
            this.form = {
                id: '',
                ocpp_version: '',
                LoadAreaID: '',
                ocpp_charge_point_id: '',
                label: ''
            };
        }
    }
};
</script>
